import { Flex, useToast } from "@chakra-ui/react";
import { AudienceDTO } from "@intentsify/dto";
import { Audience } from "@intentsify/types";
import { useMutation, useQuery } from "@tanstack/react-query";
import { apiService, Endpoints } from "api";
import { Loader, ViewContainer } from "components";
import { useNavigate, useParams } from "react-router";
import { useScreen } from "utils";
import { CreateAudienceForm } from "../../components";
import { CatalogManagerScreenDefinition } from "../CatalogManager";
import { UpdateAudienceDefinition } from "./UpdateAudience.definition";

const UpdateAudience = () => {
  useScreen(UpdateAudienceDefinition);

  const { id } = useParams<"id">();

  if (!id) {
    throw new Error("404");
  }

  const { data, isLoading: isLoadingAudience } = useQuery(
    [`audience/${id}`],
    async () => {
      const { data } = await apiService.get<Audience>(
        Endpoints.Audience.Get(Number(id))
      );
      return data;
    },
    { cacheTime: 0, staleTime: 0 }
  );

  const { mutate, isLoading } = useUpdateAudience();

  return (
    <ViewContainer>
      <Flex width="100%">
        {isLoadingAudience ? (
          <Loader />
        ) : (
          <CreateAudienceForm
            mode="edit"
            audience={data}
            isLoading={isLoading}
            onEdit={mutate}
          />
        )}
      </Flex>
    </ViewContainer>
  );
};

const useUpdateAudience = () => {
  const toast = useToast();
  const navigate = useNavigate();

  return useMutation({
    mutationFn: async ({ id, data }: { id: number; data: AudienceDTO }) => {
      await apiService.put(Endpoints.Audience.Update(id), data);
    },
    onSuccess: () => {
      toast({
        title: "Successfully update audience",
        status: "success",
      });
      navigate(CatalogManagerScreenDefinition.navigate());
    },
  });
};

export { UpdateAudience };
